import { createDraftJobPost } from './CreateDraftJobPost';
import { getDraftJobPost } from './GetDraftJobPost';
import { getJobPostings } from './GetJobPostings';
import { saveDraftJobPost } from './SaveDraftJobPost';
import { publishDraftJobPost } from './PublishDraftJobPost';

export const PermanentJobsService = {
  getJobPostings,
  createDraftJobPost,
  getDraftJobPost,
  saveDraftJobPost,
  publishDraftJobPost,
};
